import { useAuth } from "$/util/auth";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import MaskDrawingTool from "./MaskDrawingTool";

function MaskDrawingModal(props) {
  const auth = useAuth();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const midScreen = useMediaQuery(theme.breakpoints.only("md"));

  const isPro = (auth.user && auth.user.isActiveSubscription) || props.showAll;

  const handleSave = (mask, img) => {
    props.onClose(mask, img);
  };

  const handleCancel = () => {
    props.onClose(null, null, true);
  };

  // eslint-disable-next-line no-nested-ternary
  const leftPos = fullScreen ? 0 : midScreen ? 110 : 5;

  return (
    <Dialog
      open={props.open}
      onClose={handleCancel}
      fullScreen={fullScreen}
      hideBackdrop
      maxWidth={false}
      disableAutoFocus
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: theme.palette.background.default,
          borderRadius: 2,
          border: fullScreen ? "none" : `1px solid ${theme.palette.info.main}`,
          boxShadow: "2px 2px 6px rgba(0, 0, 0, 0.1)",
          maxWidth: fullScreen ? "100%" : 450,
          left: leftPos,
          // Hide scrollbar
          "&::-webkit-scrollbar": {
            display: "none",
          },
        },
      }}
    >
      <DialogTitle>Design a Custom Shape</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleCancel}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          zIndex: 100,
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          px: 2,
          pb: 2,
          pt: 0,
        }}
      >
        <Typography variant="body2" gutterBottom pb={1}>
          Draw a silhouette of the design you want by filling the area with black ink
          and leaving areas white to exclude. Black regions act as a flexible guide,
          influencing design placement based on your tattoo idea, style, and advanced
          settings.
        </Typography>
        <MaskDrawingTool onMaskChange={handleSave} maskImg={props.img} />
      </DialogContent>
    </Dialog>
  );
}

export default MaskDrawingModal;
